import React from "react";
import AppContainer from "../../../components/AppContainer";
import DynamicTable from "../../../components/DynamicTable";
import TableData from "../../../dumyData/education/EducationNewAdmissions.json";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";

const headerData = [
  "Roll Number",
  "Student Detail",
  "ID Card Status",
  "Action",
];

const displayRows = [
  "_id",
  "ed_student_detail",
  "ed_id_card_status",
  "actions",
];

const ReportCardDetail = () => {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);
  return (
    <AppContainer
      primaryHeading={"Class 1"}
      secondaryHeading={`Section A and 1st Term`}
    >
      <DynamicTable
        tableHeader={headerData}
        displayRows={displayRows}
        tableData={TableData}
        showGenerateReportButton={true}
        handleGenerateReport={() => {
          dispatch(
            setActiveTab({
              ...activeTab,
              education_report_card: "ed_report_card_template",
            })
          );
        }}
      />
      
    </AppContainer>
  );
};

export default ReportCardDetail;
